import { useTranslations } from '@storebrand-digital/fms-translations-react';
import cx from 'classnames';
import Counter from '../../shared/components/Counter/Counter';
import { Label } from '../../shared/components/Form/Form';
import styles from '../../shared/components/Input/Input.module.css';
import { FieldProps, NumberSchema } from '../types';
import { joinErrors } from '../validation/utils';
import { hasErrors } from '../validation/validateSchema';
import { PopoverContainer } from '../../pages/claimForms/components/PopoverContainer';

type CounterFieldProps = FieldProps<NumberSchema, number | null> & {
  single?: boolean;
};

export const CounterField = ({
  id,
  name,
  schema,
  value,
  errors,
  forceShowError,
  touched,
  onChange,
  single = true,
  readOnly
}: CounterFieldProps) => {
  const { getText } = useTranslations();

  const showError = !!((touched || forceShowError) && hasErrors(errors));

  const error = showError ? joinErrors(errors, getText) : undefined;

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: single ? 'column' : 'row',
          alignItems: single ? 'flex-start' : 'center',
          justifyContent: single ? 'flex-start' : 'space-between',
          padding: '5px 0'
        }}
      >
        <Label
          htmlFor={id}
          className={cx(!single && 'dsm-form-label-text--thin')}
          style={{
            marginRight: 16,
            marginBottom: single ? 8 : 0
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center' }}>
            {schema.title}
            {schema.description && (
              <PopoverContainer id={id} description={schema.description} />
            )}
          </span>
          {schema.$uiOptions?.hint && (
            <div className={styles.hint} style={{ fontWeight: 'normal' }}>
              {schema.$uiOptions.hint}
            </div>
          )}
        </Label>
        <Counter
          id={id}
          name={name}
          value={Number(value)}
          onChange={onChange}
          min={schema.minimum}
          max={schema.maximum}
          disabled={readOnly}
        />
      </div>
      {single && error && (
        <div
          style={{
            color: '#bd180a',
            fontSize: '90%',
            marginTop: 5
          }}
          id={`${id}_error`}
          role="alert"
        >
          {error}
        </div>
      )}
    </>
  );
};
